export const norwegian = {
  lang: 'nb',
  data: {
    titles: {
      active_instructors: 'Alle instruktører',
      company_information: 'Selskapsinformasjon',
      basic_information: 'Basisinformasjon',
      select_courses: 'Velg kurs',
      upload_cv: 'Last opp CV',
      and_certificates: ' og sertifikater',
      attachments: 'Vedlegg (Tillatte formater: CV - PDF/Word, Sertifikater - PDF/Word/Image)',
      about_instructor: 'Om',
      reviews: 'Tilbakemeldinger',
      contact_info: 'Kontaktinfo',
      my_courses: 'Mine kurs',
    },
    filters: {
      'templates': 'Kurs',
      'regions': 'Region',
      'search': 'Søk',
      'categories': 'Kategori',
      'reset': 'Nullstill'
    },
    form: {
      account_holder_name : {
        label:'Kontoinnehavers navn',
        placeholder:'Kontoinnehavers navn',
        error: {
          required:'Kontoinnehavers navn er påkrevd',
        }
      },
      iban: {
        label: 'IBAN-nummer',
        placeholder:'NO*********3000',
        error: {
          required:'IBAN-nummer er påkrevd',
          invalid:'Gyldig IBAN-nummer er påkrevd'
        }
      },
      first_name: {
        label: 'Fornavn',
        hint: 'Bare fornavnet ditt vil være synlig på instruktørprofilen din',
        placeholder:'Fornavn',
        error: {
          required:'Fornavn er påkrevd',
        }
      },
      last_name: {
        label:'Etternavn',
        placeholder:'Etternavn',
        error: {
          required:'Etternavn er påkrevd',
        }
      },
      email: {
        label: 'E-post',
        placeholder:'Din e-postadresse',
        error: {
          required:'E-post er påkrevd',
          invalid: 'Det kan se ut som dette er en feilstavet e-postadresse, dobbeltsjekk gjerne at den er korrekt før du går videre'
        }
      },
      confirmEmail: {
        label: 'Bekreft e-post',
        placeholder: 'Bekreft din oppgitte e-postadresse',
        error: {
          confirmEmail : 'E-postene samsvarer ikke',
        }
      },
      phone_number: {
        label: 'Telefonnummer',
        placeholder:'Telefonnummer',
        error: {
          required:'Telefonnummer er påkrevd',
          invalid: 'Telefonnummeret er ugyldig'
        }
      },
      date_of_birth: {
        label: 'Fødselsdato',
        placeholder:'YYYY-MM-DD',
        error: {
          required:'Fødselsdato er påkrevd',
        }
      },
      organization_name: {
        label:'Organisasjonsnavn',
        placeholder:'Organisasjonsnavn',
        error: {
          required:'Organisasjonsnavn er påkrevd',
        }
      },
      organization_number: {
        label:'Organisasjonsnummer',
        placeholder:'Organisasjonsnummer til ditt foretak',
        error: {
          invalid: 'Organisasjonsnummeret er ugyldig',
          required: 'Organisasjonsnummer er påkrevd',
        }
      },
      address: {
        label: 'Adresse',
        placeholder:'Adresse',
        error: {
          required:'Adresse er påkrevd',
        }
      },
      postal_code: {
        label: 'Postnummer',
        placeholder:'Postnummer',
        error: {
          invalid:'Postnummeret er ugyldig',
          required: 'Postnummer er påkrevd',
        }
      },
      city: {
        label:'Poststed',
        placeholder:'Poststed',
        error: {
          required:'Poststed er påkrevd',
        }
      },
      country: {
        label: 'Land',
        placeholder:'Land',
        error: {
          required:'Land er påkrevd',
        }
      },
      region: {
        label: 'Min region(er)',
        placeholder:'Velg i hvilke regioner du ønsker å tilby kurs',
        error: {
          required: 'Region er påkrevd',
        }
      },
      description: {
        label: 'Beskrivelse',
        placeholder:'Fyll ut en utdypende beskrivelse av deg selv til din instruktørprofil! Denne vil være synlig for brukere som skal booke dine kurs.Fyll ut en utdypende beskrivelse av deg selv til din instruktørprofil! Denne vil være synlig for brukere som skal booke dine kurs.',
        error: {
          required:'Beskrivelse er påkrevd',
        }
      },
      id_verification: {
        label: 'Vennligst last opp bilde(r) av ditt gyldige identitetsbevis og adressedokument',
        label_certificate: 'Bilde(r) av ditt identitetsbevis',
        label_address: 'Dokument som bekrefter din adresse',
        placeholder:'Velg type identitetsbevis'
      },
      offered_courses: {
        label: 'Hvilke kurs ønsker du å tilby?',
        placeholder: 'Velg de kursene du ønsker å holde',
        error: {
          required:'Du må velge minst én kursmal',
        }
      },
      boat_access: {
        label: 'Har du tilgang på båt for å holde kurset? ',
        placeholder: 'Velg ja eller nei',
        error: {
          required:'Du må velge ja eller nei',
        }
      },
      boat_type: {
        label: 'Hvis ja, hva slags båt har du og hvor mange hestekrefter har den?',
        placeholder: 'Type båt og hestekrefter',
        error: {
          required:'Du må fylle ut dette feltet dersom du har svart ja på spørsmålet over',
        }
      },
      course_access: {
        label: 'Har du tilgang til klasserom/kurslokale?',
        placeholder: 'Velg ja eller nei',
        error: {
          required:'Du må velge ja eller nei',
        }
      },
      pc_access: {
        label: 'Jeg bekrefter at jeg har tilgang til pc med powerpoint og prosjektor for å holde et klasseromskurs'
      },
      notification_preference: {
        label: 'Jeg ønsker å motta en e-post dersom det er etterspørsel etter mine type kurs i mitt område.'
      },
      accept_terms_and_conditions: {
        label: 'Jeg har lest og godtar'
      }
    },
    instructions: {
      bank_account_form: {
        stripe_payment_instruction: 'For at Stripe skal kunne gjøre utbetalinger til din konto, må du oppgi ditt fullstendige navn og IBAN-nummer til kontoen du ønsker utbetalinger til. Dine opplysninger blir håndtert sikkert av Stripe og behandles ikke av RS Sjøliv.',
        iban_number_instruction_pre_link_text: 'Finn ditt IBAN-nummer ved å gå til',
        iban_number_instruction_link_text: 'denne IBAN-kalkulatoren',
        iban_number_instruction_post_link_text: 'og tast inn ditt kontonummer eller gå til nettsiden til din bank og søk etter IBAN-nummer',
      },
      basic_info_form: {
        basic_info_instruction: 'Bli en del av RS Sjøliv-plattformen og tilby kurs! RS leverer plattform, kursinnhold og markedsfører kursene. RS tar 30% av kursomsetningen, dersom annen avtale ikke er inngått.',
        basic_info_form_fill_up_instruction_initial: 'Før du kan begynne å tilby kurs må du bli godkjent som instruktør. Fyll ut all nødvendig informasjon i de fire stegene i menyen til venstre for å sende inn en søknad. Seksjonene må fylles ut i kronologisk rekkefølge.',
        basic_info_form_fill_up_instruction_middle: ' Du må ha opprettet eget enkeltpersonsforetak på forhånd for å kunne fullføre denne søknaden!',
        basic_info_form_fill_up_instruction_last: 'Når du har blitt godkjent av RS admin vil du motta en mail med innloggingsinformasjon til et adminpanel, hvor du kan opprette kursene du ønsker å tilby. Dersom noen av dokumentene dine eller din informasjon ikke skulle bli godkjent, vil du få varsling på mail om feilen og videre prosess.',
        contact_instruction: 'Dersom du trenger hjelp, vennligst kontakt oss på',
        instructor_contact_visibility: 'Din kontaktinformasjon vil være tilgjengelig for innloggede brukere på RS Sjøliv',
        data_collection_info_text: 'Vi samler inn denne informasjonen for å bygge og bekrefte kontoen din. Det rettslige grunnlaget for behandling etter europeisk personvernlovgivning finnes i artikkel 6 (1b) i Personopplysningsloven.',
        form_invalid: 'Dette feltet må fylles inn før du kan gå videre',
        successful_application_info_initial: 'Du er nå tilknyttet RS Sjøliv plattformen som godkjent instruktør.',
        successful_application_info_middle_1: 'Logg deg inn på',
        successful_application_info_middle_2: 'for å gjøre endringer på din profil. Ønsker du å utvide kurstilbudet ditt, ta kontakt med',
        successful_application_info_last: 'Vennligst legg til informasjon om hvilke kurs du ønsker å tilby, samt nødvendig dokumentasjon for at vi skal kunne godkjenne deg som en sertifisert instruktør for nye kurs.',
        admin_web: ' adminpanelet ',
        basic_application_info_rejected_initial: 'Din søknad er avvist.',
        basic_application_info_returned_initial: 'Du kan fremdeles gjøre endringer på din søknad.',
        basic_application_info_returned_middle_1: 'Husk å laste opp nødvendige sertifikater og CV.',
        contact_customer_center_initial: 'Ta kontakt med vårt kundesenter på',
        contact_customer_center_middle_1: 'eller',
        contact_customer_center_middle_2: 'dersom du trenger hjelp.',

      },
      identity_verification_form: {
        identity_verification_form_initial: 'For å kunne motta utbetalinger for dine kurs gjennom RS Sjøliv må vår betalingsleverandør Stripe bekrefte identiteten din.',
        identity_verification_form_middle: 'Vennligst velg type identitetsbevis nedenfor og last opp bilde(r) av et gyldig identitetsbevis (kun .jpg- og .png-format støttes) og et dokument som bekrefter adressen din (e.g. strøm- eller internettregning, signert leiekontrakt, andre dokumenter utstedt av myndighetene). Bildene må være av god kvalitet og ikke være større enn 10MB. Adressedokumentet kan ikke være eldre enn 6 måneder og adressen må stemme overens med den du fylte ut i forrige steg.',
        identity_verification_form_last: 'Dine identitetsdokumeter blir sendt direkte til Stripe for autentisering. RS Sjøliv verken håndterer eller lagrer dine dokumenter.',
        identity_verification_form_save_instruction:'Trykk last opp og deretter trykk lagre og gå videre for å fortsette søknaden.'
      },
      my_courses: {
        cv_and_certificates_upload: 'Vennligst last opp din CV og relevante sertifikater for kursene du ønsker å holde. Din CV bør inneholde referanser fra tidligere arbeidsgivere eller kursdeltakere.',
        instructor_template_page_link: 'Klikk her',
        instructor_template_page_info_text: 'for å lese mer om hvilke sertifiseringer og kurs du trenger for de ulike kurstypene.',
        no_cv_and_certificates: 'Vennligst last opp minst én CV',
        required_text: 'NB: Felter med stjerne må fylles ut før du sender inn skjemaet.'
      }
    },
    action_buttons: {
      back: 'Tilbake',
      next: 'Neste',
      update: 'Oppdater',
      save_for_later: 'Lagre for senere',
      upload: 'Last opp',
      upload_cv: 'Last opp CV',
      upload_certificate: 'Last opp sertifikater',
      save_and_proceed: 'Lagre og gå videre',
      send_request: 'Send søknad'
    },
    tabs: {
      instructor_request: {
        basic_information: 'Basisinformasjon',
        id_verification: 'ID-verifisering',
        bank_account: 'Bankkonto',
        my_courses: 'Kurs',
        my_feedbacks: 'Tilbakemeldinger'
      }
    },
    feedback_table: {
      id: 'Sr. No',
      created_at: 'Opprettelsesdato',
      description: 'Beskjed',
    },
    card: {
      review: 'Anmeldelse',
      reviews: 'Anmeldelser',
      one_course: 'kurs',
      distinct_courses: 'ulike typer kurs'
    },
    or: 'eller',
    frontpage: 'FREMSIDE',
    backpage: 'BAKSIDE',
    terms_and_conditions: 'Vilkår og betingelser',
    thank_you: 'Takk for din interesse for å tilby kurs på RS Sjøliv!',
    become_an_instructor: 'Bli instruktør',
    thank_you_application:'Takk for søknaden!',
    instructor_request_success: 'Du vil snart motta en e-postbekreftelse på søknaden din. Når dine dokumenter og informasjon er behandlet og godkjent, vil du motta en ny e-post med lenke til adminportalen hvor du kan opprette og publisere kurs.',
    go_to_homepage: 'Gå til forsiden',
    verified_by: 'Verifisert av Redningsselskapet',
    name: 'Navn',
    email: 'E-post',
    phone_number: 'Telefonnummer',
    read_more: 'Les mer',
    read_less: 'Les mindre',
    reviews: "tilbakemeldinger",
    review: "tilbakemelding",
    registration_or_login_prompt: 'Registrer deg/Logg inn for å kontakte instruktøren'
  },
};
